// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NTPS","footer":"styles_footer__W6qw6","passCodeTooltip":"styles_passCodeTooltip__3yjUQ"};